module.exports = __webpack_public_path__ + "img/smallbilltut.da841a90.png";